var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPpt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#D04423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.976 222V204.864H104.216C114.584 204.864 120.344 197.808 120.344 189.456C120.344 181.032 114.656 173.976 104.216 173.976H81.752V222H91.976ZM102.776 195.864H91.976V182.976H102.776C106.808 182.976 109.904 185.424 109.904 189.456C109.904 193.416 106.808 195.864 102.776 195.864Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.976 222V204.864H149.216C159.584 204.864 165.344 197.808 165.344 189.456C165.344 181.032 159.656 173.976 149.216 173.976H126.752V222H136.976ZM147.776 195.864H136.976V182.976H147.776C151.808 182.976 154.904 185.424 154.904 189.456C154.904 193.416 151.808 195.864 147.776 195.864Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.136 222V182.976H207.104V173.976H168.8V182.976H182.84V222H193.136Z",
    fill: "#F9F9F9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPpt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ppt.190757202a58e5872667e6eb3af8df46.svg";